"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getCartClient = getCartClient;
exports.isWalletProduct = exports.isValidProduct = exports.isRuleProduct = exports.isQitafProduct = exports.isMokafaaProduct = exports.isLoyaltyProduct = exports.isHotelProduct = exports.isGiftCard = exports.isFlightProduct = exports.isDisplayable = exports.isCouponProduct = exports.isCartType = exports.isAccommodation = void 0;
var _accommodationCart = require("../clients/accommodation-cart.client");
var _flightCart = require("../clients/flight-cart.client");
var _hotelCart = require("../clients/hotel-cart.client");
var _constants = require("../constants");
var _cart = require("../clients/cart.client");
var _get2 = _interopRequireDefault(require("lodash/get"));
const {
  HOTEL,
  FLIGHT,
  LOYALTY,
  WALLET,
  QITAF,
  RULE,
  COUPON,
  ACCOMMODATION,
  GIFTCARD,
  MOKAFAA
} = _constants.CART_PRODUCT_TYPES;

/**
 * isValidProduct
 * @description this util function checks whether a given cart product is valid or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
const isValidProduct = p => p.valid;

/**
 * isHotelProduct
 * @description this util function checks whether a given cart product is hotel or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isValidProduct = isValidProduct;
const isHotelProduct = p => p.type === HOTEL;

/**
 * isFlightProduct
 * @description this util function checks whether a given cart product is flight or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isHotelProduct = isHotelProduct;
const isFlightProduct = p => p.type === FLIGHT;

/**
 * isCartType
 * @description this util function return cart product type
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isFlightProduct = isFlightProduct;
const isCartType = p => [HOTEL, FLIGHT, ACCOMMODATION, GIFTCARD].includes(p.type);

/**
 * isC2CProduct
 * @description this util function checks whether a given cart product is chalet or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isCartType = isCartType;
const isAccommodation = p => p.type === ACCOMMODATION;

/**
 * isGiftCardProduct
 * @description this util function checks whether a given cart product is giftCard or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isAccommodation = isAccommodation;
const isGiftCard = p => p.type === GIFTCARD;

/**
 * isLoyaltyProduct
 * @description this util function checks whether a given cart product is loyalty or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isGiftCard = isGiftCard;
const isLoyaltyProduct = p => p.type === LOYALTY;

/**
 * isWalletProduct
 * @description this util function checks whether a given cart product is wallet or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isLoyaltyProduct = isLoyaltyProduct;
const isWalletProduct = p => p.type === LOYALTY && p.category === WALLET;

/**
 * isQitafProduct
 * @description this util function checks whether a given cart product is qitaf or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isWalletProduct = isWalletProduct;
const isQitafProduct = p => p.type === LOYALTY && p.category === QITAF;

/**
 * isMokafaaProduct
 * @description this util function checks whether a given cart product is qitaf or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isQitafProduct = isQitafProduct;
const isMokafaaProduct = p => p.type === LOYALTY && p.category === MOKAFAA;

/**
 * isCouponProduct
 * @description this util function checks whether a given cart product is coupon or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isMokafaaProduct = isMokafaaProduct;
const isCouponProduct = p => p.type === RULE && p.category === COUPON;

/**
 * isRuleProduct
 * @description this util function checks whether a given cart product is rule or not
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isCouponProduct = isCouponProduct;
const isRuleProduct = p => p.type === RULE && p.category === RULE;

/**
 * isRuleProduct
 * @description this will filter out all rules that has displayRule as MERGE_ALL
 * @param {Object} p plain unformatted cart product object (the letter `p` for product)
 * @returns {boolean}
 */
exports.isRuleProduct = isRuleProduct;
const isDisplayable = p => {
  const displayRule = (0, _get2.default)(p, 'options.displayRule', '');
  return isRuleProduct(p) && displayRule !== _constants.DISPLAY_RULES.MERGE_ALL;
};

/**
 * get cart client based on product type
 * @param {string} type
 * @return {Object} client
 */
exports.isDisplayable = isDisplayable;
function getCartClient({
  type
}) {
  const cartClientMap = {
    [HOTEL]: _hotelCart.HotelCartClient,
    [FLIGHT]: _flightCart.FlightCartClient,
    [ACCOMMODATION]: _accommodationCart.AccommodationCartClient,
    [GIFTCARD]: _cart.CartClient
  };
  return (0, _get2.default)(cartClientMap, `${type}`);
}